import React, {useEffect, useState} from 'react';
import { ColorPicker, useColor, toColor } from "react-color-palette";
import "react-color-palette/lib/css/styles.css";
import * as SharedAcross from '../utilities/SharedAcross';
import * as StyleFunctions from '../utilities/StyleFunctions';

function App(props) {

  var origColorSet = props.currentStyle;
  var submitColor = props.submitColor;
  var allowFormula = props.allowFormula;
  var currentList = props.currentList;
  var width = props.width;
  var e1 = props.e;
  var hideHEX = props.hideHEX;
  var hideRGB = props.hideRGB;
  var mostRecentColorOrig = props.mostRecentColor;
  var setMostRecentColor = props.setMostRecentColor;
  var colorType = props.colorType;
  var logPath = props.logPath;
  var organicChanges = props.organicChanges;
  var styles = props.styles;

  var isFormula = false;
  var red = 0;
  var green = 0; 
  var blue = 0;
  var origColor;
  var rgbPiece = '';
  var hex = '';

  const [mostRecentColor, _setMostRecent] = useState(mostRecentColorOrig);

  function actuallyChangeHex(answerHere){
    var tt = SharedAcross.hexToRgb(answerHere);
    var txt = 'rgb(' + tt.r + ', ' + tt.g + ', ' + tt.b + ')';
    submitColor(txt);
    var colourOut = toColor("rgb", tt);
    setMostRecentColor(colourOut);
    setColor(colourOut);
  }

  if (origColorSet){
    if (origColorSet.t !== 'formula'){
        origColor = origColorSet.v;
        hex = StyleFunctions.getHEXFromText(origColor).toUpperCase();
        if (hex){
          var tt = SharedAcross.hexToRgb(hex);
          red = tt.r;
          green = tt.g;
          blue = tt.b;          
        }
    }
  }
//  
  if (hideHEX){

    function changeAValue(e){


        var sel = document.getSelection();
        var answerHere = window.prompt('New Hex Value', hex);
        var range = document.createRange();
        range.setStart(sel.anchorNode, sel.anchorOffset);
        range.setEnd(sel.focusNode, sel.focusOffset);
        sel.removeAllRanges()
        sel.addRange(range);

        if (!answerHere){
          actualNoColor();
          return;
        }

        answerHere = answerHere.trim().toUpperCase();
        if (!SharedAcross.isValidHexColor(answerHere)){
          window.alert('Sorry, a hex string needs to be of the form #ABCDEF');
          return;
        }

        actuallyChangeHex(answerHere);    
    }

    var ttt = 'Color : ' + hex;
    if (!hex){
      ttt = 'No Color';
    }
    rgbPiece = <div style={{cursor:'pointer'}} onClick={changeAValue}><u>{ttt}</u></div>
  }
//        

  if (origColorSet){
    if (origColorSet.t === 'formula'){
      isFormula = true;
    }
  }

  const [color, setColor] = useColor("rgb", {r:red, g:green, b:blue});

  useEffect(()=>{
    var colourOut = toColor("rgb", {r:red, g:green, b:blue});
    setColor(colourOut);
  }, [origColorSet]); // eslint-disable-line react-hooks/exhaustive-deps

//
  function setColor1(e){
    var cc = "rgb(" + e.rgb.r + ', ' + e.rgb.g + ', ' + e.rgb.b + ')'
    submitColor(cc);
    setMostRecentColor(e);
    setColor(e);
  }

  function clickMostRecentColor(e){
    var cc = "rgb(" + mostRecentColor.rgb.r + ', ' + mostRecentColor.rgb.g + ', ' + mostRecentColor.rgb.b + ')'
    submitColor(cc);
    setColor(mostRecentColor);
  }
//    
  var noColorStyle = {}
  if (!origColor && !isFormula){
    noColorStyle.fontWeight = 600;
    noColorStyle.color = 'blue';
  }

  function actualNoColor(){
    submitColor(false);
    var colourOut = toColor("rgb", {r:0, g:0, b:0});
    setColor(colourOut);
  }          

  function clickNoColor(e){
    actualNoColor();
    e.stopPropagation();
  }

  var formulaPiece;
  if (allowFormula){
    var formStyle = {paddingLeft:'10px'};
    if (isFormula){
      formStyle.fontWeight = 600;
    }
    if (e1){
      formStyle.color = 'red';
    }
    formulaPiece = <div style={formStyle} onClick={function(e){allowFormula()}}><u>Formula</u></div>
  }

  var removeColorPiece;
  if (hex){
    removeColorPiece = <div style={noColorStyle} onClick={clickNoColor} onMouseDown={onMouseDown}>[Remove Color]</div>
//
  }

  var palettes = currentList.cp;
  var paletteKeys = Object.keys(palettes);

  function clickPalette(val){
    return function(e){
      actuallyChangeHex(val);
    }
  }

  var palettePieces = paletteKeys.map((aP, index)=>{
    var thisPalette = palettes[aP];
    var thisPaletteKeys = Object.keys(thisPalette);

    var cells = thisPaletteKeys.map((aP1, index2)=>{
      return <td style={{backgroundColor:thisPalette[aP1], height:'20px', cursor:'pointer', border:'1px solid black'}} className='cellSelector' onClick={clickPalette(thisPalette[aP1])} key={index2}></td>
//
    })
    return <table style={{width, marginTop:'10px', marginBottom:'10px'}} key={index} ><tbody><tr>{cells}</tr></tbody></table>
//
  })  

  var mostRecentPiece;
  if (mostRecentColor){
    var cc = "rgb(" + mostRecentColor.rgb.r + ', ' + mostRecentColor.rgb.g + ', ' + mostRecentColor.rgb.b + ')'

    mostRecentPiece = <div className='selectionLight' style={{width, marginTop:'10px', marginBottom:'10px', border:'1px solid black',borderRadius:'3px',  backgroundColor:cc}} onClick={clickMostRecentColor}>Most Recent Color</div>
  }
//
  var logPiece;
  if (colorType){
    var tagP = '';
    var textPTag = '';
    if (styles && styles.tags && styles.tags[colorType]){
      tagP = styles.tags[colorType]
    }
    function changeTag(e){
      var p = window.prompt('New Tag? (Integer between 1 and 7)', tagP);
      var isInt = SharedAcross.isIntegerText(p);
      if (isInt){
        if (+p > 0 && +p < 8){
          organicChanges([{t:'w',w:logPath.concat(['tags', colorType]),n:+p}])
          return;
        }
      }
      organicChanges([{t:'r',w:logPath.concat(['tags']),i:colorType}])
    }
    textPTag = tagP;
    if (!tagP){
      textPTag = 'None';
    }
    logPiece = <p className='lead mb-0' style={{cursor:'pointer', textDecoration:'underline'}} onClick={changeTag}>Tag : {textPTag}</p>
  }
//
  return <div >
    {mostRecentPiece}
    {palettePieces}
    <ColorPicker width={width} height={width} color={color} onChange={setColor1} hideHSV hideHEX={hideHEX} hideRGB={hideRGB} dark />
      {rgbPiece}
      {removeColorPiece}{formulaPiece}
      {logPiece}
    </div>
}
//
  function onMouseDown(e){
    e.preventDefault();
  }

export default App;
